import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  excerpt: string;
  date: string;
  author: string;
  image: string;
  tags: string[];
  views: number;
}

export default function ArticleCard({
  id,
  title,
  excerpt,
  date,
  author,
  image,
  tags,
  views,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
    >
      <div className="overflow-hidden rounded-lg aspect-[16/10] bg-background-200 mb-3">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
          title={title}
        />
      </div>
      <div className="flex items-center gap-2 mb-2 flex-wrap">
        {tags.slice(0, 2).map((tag) => (
          <span
            key={tag}
            className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium"
          >
            {tag}
          </span>
        ))}
      </div>
      <h3 className="text-base font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors mb-1.5">
        {title}
      </h3>
      <p className="text-sm text-foreground-600 line-clamp-2 mb-2 leading-relaxed">
        {excerpt}
      </p>
      <div className="flex items-center gap-3 text-xs text-foreground-400">
        <span>{author}</span>
        <span>{date}</span>
        <span>{views.toLocaleString()} 阅读</span>
      </div>
    </Link>
  );
}